document.addEventListener("DOMContentLoaded", () => {
  const openModalButtons = document.querySelectorAll("[data-open-modal]");
  const modalContainer = document.getElementById("modal-container");
  const modalContentContainer = document.getElementById("modal-content");
  const modalOverlay = document.querySelector(".modal-overlay");
  const body = document.body;

  openModalButtons.forEach((button) => {
    button.addEventListener("click", () => {
      // Move the modal content to the modal container
      const modalContent = button.parentNode.querySelector("modal-content");
      if (modalContent) {
        modalContentContainer.innerHTML = modalContent.innerHTML;
        modalContainer.classList.remove("hidden");
        modalOverlay.classList.remove("hidden");
        body.classList.add("no-scroll");

        const closeButton = modalContentContainer.querySelectorAll(".close");
        if (closeButton) {
          closeButton.forEach((close) =>
            close.addEventListener("click", closeModal)
          );
        }
      }
    });
  });

  const closeModal = () => {
    modalContainer.classList.add("hidden");
    modalOverlay.classList.add("hidden");
    body.classList.remove("no-scroll");
    // Move the modal content back to its original place
    modalContent.appendChild(modalContentContainer.firstElementChild);
  };
});
